import React from "react";
import KioskLayout from "components/Layout/KioskLayout";
import EventDetail from "components/Kiosk/Event/EventDetail";
import MapRouterMaster from "containers/MapRouterMaster";
import useDestination from "hooks/useDestination";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import { mainApiPath } from "api/constants";
import { mapRouterType , screenKeys , gaSettings } from "config/constants";

const KioskPromotionDetail = (props) => {
  const [error, loading, promotionDetail] = useFetch(
    mainApiPath.promotion  + '/' + props.match.params.id
  );

  const destination = useDestination(props.location.search);

  const gaTitle = gaSettings.promotionDirect.title;
  const gaLocation = promotionDetail?.title
    ? gaSettings.promotionDirect.location + promotionDetail.title
    : null;
  useGaPageView({ gaTitle, gaLocation });

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk + '/' +  screenKeys.promotion}
      left={
        <MapRouterMaster
          type={mapRouterType.pathGuide}
          slotInfo={destination}
          destinationName={promotionDetail ? promotionDetail.destination_name : ''}
          layout={'kiosk'}
        />
      }
      right={
        <EventDetail
          details={promotionDetail ? promotionDetail : null}
          loading={loading}
          apiPath={mainApiPath.promotion}
        />
      }
    />
  );
};

export default KioskPromotionDetail;
